import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { SelectCore } from '../../../core';
import { useBaseSelect } from '../hooks';

function BaseSelectCore(props) {
  var children = props.children,
      meta = props.meta,
      propInitialSelectedItem = props.initialSelectedItem;
  var initialSelectedItem = meta && meta.initialValue ? meta.initialValue : propInitialSelectedItem;

  var _useBaseSelect = useBaseSelect(_objectSpread({
    initialSelectedItem: propInitialSelectedItem
  }, props)),
      stateReducer = _useBaseSelect.stateReducer,
      itemsResolver = _useBaseSelect.itemsResolver,
      handleOnChange = _useBaseSelect.handleOnChange,
      handleInputValueChange = _useBaseSelect.handleInputValueChange,
      BaseSelectCoreInner = _useBaseSelect.BaseSelectCoreInner;

  return /*#__PURE__*/React.createElement(SelectCore, _extends({}, props, {
    items: itemsResolver,
    initialSelectedItem: initialSelectedItem,
    stateReducer: stateReducer,
    onChange: handleOnChange,
    onInputValueChange: handleInputValueChange
  }), /*#__PURE__*/React.createElement(BaseSelectCoreInner, null, children));
}

export default BaseSelectCore;